import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  DataTable,
  Button,
  DataTableSkeleton,
  Modal
} from "carbon-components-react";
import Numeral from "numeral";
import actions from "../../../redux/modules/user";
import mainActions from "../../../redux/modules/main";
import { getDmService, deleteDmService } from "../../../services/Api";
import { Breadcrumb } from "../../../components";
import "numeral/locales/pt-br";
import { Card } from '../../../components';

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader
} = DataTable;

class Cart extends Component {
  constructor() {
    super();

    this.state = {
      items: [],
      subTotal: 0,
      isLoading: true,
      saldoAtual: 0,
      mdConfirmDelete: false,
      width: 0
    };
  }

  componentDidMount = async () => {
    Numeral.locale("pt-br");
    await this.getItems();
    await this.getSaldoAtual();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  getItems = async () => {
    const { loadCounters, loadUser } = this.props;
    loadCounters();
    loadUser();

    try {
      const items = await getDmService("/Pedido/MostraCarrinho");
      let subTotal = 0;

      if (items.carrinho.length) {
        items.carrinho.forEach(item => {
          subTotal += item.tipo !== "Agência" ? item.valorTotal : 0;
        });
        this.setState({ items: items.carrinho, isLoading: false, subTotal });
      } else {
        this.setState({ items: [], isLoading: false, subTotal });
      }
    } catch (ex) {
      this.setState({ isLoading: false });
      toast.error("Ocorreu uma falha ao carregar os itens");
    }
  };

  getSaldoAtual = async () => {
    try {
      const data = await getDmService("/Orcamento/SaldoAtual");
      const { saldoAtual } = data;
      this.setState({
        saldoAtual
      });
    } catch (error) {
      console.log(error);
    }
  };

  getRow = (row, headers, type) =>
    headers.map(header => {
      const cell = row.cells.find(p => p.info.header === header.key);
      const value =
        header.key.indexOf("valor") !== -1
          ? Numeral(cell.value).format("$ 0.00")
          : header.key.indexOf("subTotal") !== -1
            ? Numeral(cell.value).format("$ 0.00")
            : cell.value;

      if (type === "Agência") {
        return (
          <TableCell
            key={cell.id}
            className="pointer"
            onClick={() => this.goEditAgency(cell)}
          >
            {value}
          </TableCell>
        );
      }

      return (
        <TableCell
          key={cell.id}
          className="pointer"
          onClick={() => this.goEdit(row)}
        >
          {value}
        </TableCell>
      );
    });

  openConfirmDelte = row => {
    this.setState(prevState => ({
      mdConfirmDelete: !prevState.mdConfirmDelete,
      idDelete: row && row.id ? row.id : 0
    }));
  };

  deleteItemCart = async () => {
    const { loadCounters } = this.props;
    const { idDelete } = this.state;
    try {
      await deleteDmService("/Pedido/RemoveProdutoCarrinho", idDelete);
      await this.openConfirmDelte(false);

      loadCounters();
      await this.getItems();
      toast.success("Item removido com sucesso");
    } catch (ex) {
      toast.error("Não foi possível remover o item");
    }
  };

  checkoutTrade = async () => {
    const { history } = this.props;
    history.push("/carrinho/checkout-trade");
  };

  checkoutAgencia = async () => {
    const { history } = this.props;
    history.push("/carrinho/checkout-agencia");
  };

  goEdit = row => {
    const { items } = this.state;
    const { history } = this.props;
    //  const idsItems = items[0].produtos.resultado.map(item => ({id: item.id, idProd: item.idProduto}))

    let idsItems = [];
    for (const obj of items) {
      console.log("aqui");
      idsItems = obj.produtos.resultado.map(item => ({
        id: item.id,
        idProd: item.idProduto
      }));
    }

    let idProduct = 0;
    for (const item of idsItems) {
      if (item.id === row.id) {
        idProduct = item.idProd;
      }
    }
    if (idProduct !== 0) {
      history.push(`/trade/brinde/${idProduct}`);
    }
  };

  goEditAgency = row => {
    const { history } = this.props;
    const { width } = this.state;
    const idRequest = width < 1024 ? row.id : row.id.split(":")[0];
    history.push(`/agencia/pedido/${idRequest}`);
  };

  render() {
    const {
      items,
      saldoAtual,
      subTotal,
      isLoading,
      mdConfirmDelete,
      width
    } = this.state;
    const saldo = parseFloat(saldoAtual) - parseFloat(subTotal);

    if (isLoading) {
      return (
        <div>
          <Breadcrumb title="---- - ----" description="----" />

          <section className="content-wrapper content-wrapper--large">
            <DataTableSkeleton />
          </section>
        </div>
      );
    }
    return (
      <div>
        <Breadcrumb
          title="Carrinho"
          description="Confira os itens no seu carrinho"
          renderRight={(() => (
            <div className="bread-info">
              <span className="text">
                <span className="text-light">Meu Budget: </span>
                <strong>{Numeral(saldoAtual + 0).format("$ 0.00")} </strong>
                {subTotal !== 0 && (
                  <React.Fragment>
                    {"(-"}
                    {Numeral(subTotal).format("$ 0.00")}
                    {")"}
                  </React.Fragment>
                )}
              </span>
              <span className="text">
                {subTotal !== 0 && (
                  <React.Fragment>
                    <span className="text-light">Saldo: </span>
                    <strong>{Numeral(saldo).format("$ 0.00")}</strong>
                  </React.Fragment>
                )}
              </span>
            </div>
          ))()}
        />
        <div className="content-wrapper content-wrapper--large">
          {items.length === 0 && (
            <div>
              <div className="empty-cart">
                <i className="material-icons">shopping_cart</i>
                <h3>Carrinho vazio</h3>
              </div>
            </div>
          )}
          {items &&
            items.map(item => (
              <div key={`item${item.id}`} className="cart-table">
                <h3 className="header-cart">
                  {item.tipo} ({item.totalProdutos})
                </h3>
                <DataTable
                  rows={item.produtos.resultado}
                  headers={item.produtos.header}
                  render={({ rows, headers, getHeaderProps }) => (
                    <TableContainer>
                      <Table className="responsive-carbon-table">
                        <TableHead>
                          <TableRow>
                            {width < 1024 && (<TableHeader />)}
                            {width >= 1024 && headers.map(header => (
                              <TableHeader {...getHeaderProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                          </TableRow>
                          <th />
                        </TableHead>
                        <TableBody>
                          {width < 1024 && rows.map(row => (
                            <TableRow key={`${row.id}`}>
                              <TableCell
                                key={`row-${row.id}`}
                                className="pointer"
                                onClick={() => this.goEditAgency(row)}
                              >
                                <Card className="table-card">
                                  {row.cells.map(cell => (
                                    <p>
                                      {headers.find(obj => obj.key === cell.info.header).header}
                                      :
                                      <strong>{` ${['valor', 'subTotal'].includes(cell.info.header) ? (Numeral(cell.value).format("$ 0.00")) : cell.value || ""}`}</strong>
                                    </p>
                                  ))}
                                </Card>
                              </TableCell>
                              <td>
                                <button
                                  onClick={() => this.openConfirmDelte(row)}
                                  type="submit"
                                  className="button button--clear danger  pointer f-left"
                                >
                                  <i className="material-icons">
                                    delete_outline
                                  </i>
                                </button>
                              </td>
                            </TableRow>
                          ))}
                          {width >= 1024 && rows.map(row => (
                            <TableRow key={`${row.id}`}>
                              {this.getRow(row, headers, item.tipo)}
                              <td>
                                <button
                                  onClick={() => this.openConfirmDelte(row)}
                                  type="submit"
                                  className="button button--clear danger  pointer f-left"
                                >
                                  <i className="material-icons">
                                    delete_outline
                                  </i>
                                </button>
                              </td>
                            </TableRow>
                          ))}
                          {width < 1024 && (
                            <TableRow>
                              <td colSpan={headers.length - 1}>
                                <div className="total-carrinho">
                                  {`Valor Total ${item.tipo}`}
                                  <strong>
                                    {Numeral(item.valorTotal).format("$ 0.00")}
                                  </strong>
                                </div>
                              </td>
                            </TableRow>
                          )}
                          {width >= 1024 && (
                            <TableRow>
                              <td colSpan={headers.length - 1}>
                                <div className="total-carrinho">
                                  {`Valor Total ${item.tipo}`}
                                </div>
                              </td>
                              <td>
                                <strong>
                                  {Numeral(item.valorTotal).format("$ 0.00")}
                                </strong>
                              </td>
                              <td />
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />

                <div className="bx--col-xs-12  v-md-margin">
                  <Button
                    kind="primary"
                    className="bx--btn bx--btn--full-width btn-secondary-color"
                    type="submit"
                    onClick={
                      item.tipo === "Trade"
                        ? this.checkoutTrade
                        : this.checkoutAgencia
                    }
                  >
                   Enviar Pedido
                  </Button>
                </div>
              </div>
            ))}
        </div>
        <Modal
          modalHeading="Remover Item"
          primaryButtonText="Tenho Certeza"
          secondaryButtonText="Cancelar"
          onRequestSubmit={() => this.deleteItemCart()}
          onRequestClose={() => this.openConfirmDelte(false)}
          open={mdConfirmDelete}
        >
          <p>Você tem certeza que deseja remover este produto do carrinho?</p>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadUser() {
    dispatch(actions.receiveUserData());
  },
  loadCounters() {
    return dispatch(mainActions.receiveCounters());
  }
});

const mapStateToProps = state => ({
  user: state.user.data
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);



// WEBPACK FOOTER //
// ./src/screens/client/cart/index.js